import { SelectComponents } from '@frontend/components';

import { UNASSIGNED_VALUE } from 'modules/common/smartComponents/const';

import { ANYBODY_VALUE } from '../const';
import { CustomAvatar } from './CustomAvatar';

export const Option = ({ children, ...restProps }) => {
  const { label, value } = restProps.data;
  const name =
    value !== UNASSIGNED_VALUE && value !== ANYBODY_VALUE ? label : undefined;
  return (
    <SelectComponents.Option {...restProps}>
      <CustomAvatar
        name={name}
        backgroundColor={restProps.data.avatarColor}
        marginRight={0.5}
      />
      {children}
    </SelectComponents.Option>
  );
};
